import React from "react";
import DrpEeduHeader from "../../components/DrpEeduHeader";
import DrpEduNavbar from "../../components/DrpEduNavbar";
import Footer from "../../components/Footer";

const PhilippinesMbbs = () => {
  return (
    <>
      <DrpEeduHeader />
      <DrpEduNavbar />{" "}
      <div className="mbbs-country-page">
        <section className="country-header">
          <h2 className="country-title">🩺 MBBS in the Philippines</h2>
        </section>

        <section className="details-section">
          <div className="detail-item">
            <h3 className="detail-title">Degree Awarded:</h3>
            <p className="detail-text">
              MD (Doctor of Medicine) — equivalent to MBBS in India
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Duration:</h3>
            <p className="detail-text">
              5.5 to 6 years (1.5-2 years BS Pre-med + 4 years MD)
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Eligibility:</h3>
            <ul className="detail-list">
              <li>10+2 with Physics, Chemistry, Biology, and English</li>
              <li>Minimum 50% marks in PCB</li>
              <li>Must qualify NEET (for Indian students)</li>
              <li>
                NMAT (National Medical Admission Test) is required after the BS
                program.
              </li>
            </ul>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Medium of Instruction:</h3>
            <p className="detail-text">English</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Recognition:</h3>
            <p className="detail-text">NMC (India), WHO, ECFMG, FAIMER</p>
          </div>
        </section>

        <section className="universities-section">
          <h2 className="section-title">
            🎓 Top Medical Universities in the Philippines
          </h2>
          <div className="university-list">
            <div className="university-card">
              <h3 className="university-name">
                University of the Philippines – Manila
              </h3>
              <p className="university-description">
                Prestigious government university. Top-ranked in research and
                clinical education.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                University of Santo Tomas (UST), Manila
              </h3>
              <p className="university-description">
                One of the oldest universities in Asia (est. 1611). Renowned
                College of Medicine and Surgery.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Cebu Institute of Medicine (CIM), Cebu City
              </h3>
              <p className="university-description">
                Highly respected for clinical training. NMAT scores required for
                entry to MD.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Davao Medical School Foundation (DMSF), Davao
              </h3>
              <p className="university-description">
                Popular among Indian students. Good infrastructure and Indian
                food availability.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Our Lady of Fatima University (OLFU), Valenzuela
              </h3>
              <p className="university-description">
                Recognized by NMC and WHO. Large number of Indian students;
                offers BS-MD program.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                AMA School of Medicine, Manila/Makati
              </h3>
              <p className="university-description">
                Offers affordable BS-MD programs. English-medium instruction and
                NMC recognized.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Saint Louis University, Baguio
              </h3>
              <p className="university-description">
                Well-established medical faculty. Known for quality academics
                and research.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Bicol Christian College of Medicine, Legazpi
              </h3>
              <p className="university-description">
                Offers affordable tuition fees. Approved by NMC and WHO.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Emilio Aguinaldo College (EAC), Manila
              </h3>
              <p className="university-description">
                Urban campus, good facilities. Well known among Indian students.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                UV Gullas College of Medicine, Cebu
              </h3>
              <p className="university-description">
                Affordable and NMC-approved. Offers Indian food and hostel
                facilities.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default PhilippinesMbbs;
